<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="[$t('roundplanningview.unit_singular'), $t('roundplanningview.unit_plural'), $t('roundplanningview.new')]"
			:pagination="pagination"
			:showCustomer="true"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			:hide-add="!$isAllowedTo('roundplannings_create')"
			@toggleAdd="navigate"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view columns">
			<RoundPlanningList
				:roundPlannings="roundPlannings"
				@delete="askToDelete"
				@edit="edit"
				@search="getRoundPlannings"
			/>
		</main>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import RoundPlanningList from './components/RoundPlanningList';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';

export default {
	components: {
		RoundPlanningList,
		DeleteModal,
		TopPanel
	},

	data() {
		return {
			showDelete: false,
			selectedRoundPlanning: { id: null, name: '' },
		};
	},

	computed: {
		...mapState('roundPlanningStore', ['searchParams']),
		...mapGetters('roundPlanningStore', ['roundPlannings', 'pagination']),
		...mapGetters('user', ['getActiveCustomer']),

		deleteMessage() {
			return this.selectedRoundPlanning.name
				? this.$t('roundplanningview.delete_message', { name: this.selectedRoundPlanning.name })

				: '';
		},

		orderBys() {
			return [
				{ name: this.$t('roundplanningview.order_by_name'), value: 'Name' },
				{ name: this.$t('roundplanningview.order_by_created'), value: 'Created' }
			];
		}
	},

	watch: {
		'getActiveCustomer.id'() {
			this.SET_ROUNDPLANNINGS([]);
			this.getRoundPlannings();
		}
	},

	created() {
		this.searchParams.buildingId = null;
		this.SET_ROUNDPLANNINGS([]);
		this.getRoundPlannings();
	},

	methods: {
		...mapActions('roundPlanningStore', ['getRoundPlannings', 'deleteRoundPlanning']),
		...mapMutations('roundPlanningStore', ['SET_ROUNDPLANNINGS']),

		navigate() {
			const capability = this.selectedRoundPlanning.id ? 'roundplannings_edit' : 'roundplannings_create';
			if (!this.$isAllowedTo(capability)) return;

			let id = this.selectedRoundPlanning.id || 0;
			this.$router.push({
				name: 'RoundPlanningDetailView',
				params: {
					roundPlanningId: id
				}
			});
		},

		edit(roundPlanning) {
			if (!this.$isAllowedTo('roundplannings_edit')) return;

			Object.assign(this.selectedRoundPlanning, roundPlanning);
			this.navigate();
		},

		askToDelete(payload) {
			if (!this.$isAllowedTo('roundplannings_delete')) return;

			const id = (payload && (payload.id ?? payload.Id)) ?? payload ?? null;

			let name = (payload && (payload.name ?? payload.Name)) ?? '';
			if (!name) {
				const rp = this.roundPlannings.find(
				x => (x.id ?? x.Id) === id
				);
				name = rp ? (rp.name ?? rp.Name ?? '') : '';
			}

			this.selectedRoundPlanning = { id, name };

			this.$nextTick(() => { this.showDelete = true; });
		},

		cancelDelete() {
			this.showDelete = false;
			this.selectedRoundPlanning = { id: null, name: '' };
		},

		deleteSelected() {
			if (!this.$isAllowedTo('roundplannings_delete')) return;

			this.deleteRoundPlanning(this.selectedRoundPlanning).then(() => {
				this.showDelete = false;
				this.selectedRoundPlanning = { id: null, name: '' };
			});
		},

		search(searchValue) {
			this.searchParams.search = searchValue;
			this.getRoundPlannings();
		},

		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getRoundPlannings();
		}
	}
};
</script>
